import { CSSObject } from '@emotion/react'

export const titleCase: CSSObject = {
  textTransform: 'capitalize',
}
